import React, { useState } from "react";
import "../Style/Webdoubts.css";

import arrowIcon from "../assets/blue-arrow.png";

const faqData = [
  {
    question: "How long does it take to develop a website?",
    answer:
      "The development timeline depends on your project's size and complexity. A standard business website usually takes 2–6 weeks, while custom web applications and enterprise websites may require additional development time.",
  },
  {
    question: "How much does website development cost?",
    answer:
      "Website development costs vary based on design, functionality, integrations, and business requirements. We provide customized quotes to ensure you receive the best value for your investment.",
  },
  {
    question: "Will my website be mobile-friendly?",
    answer:
      "Yes. Every website we build follows a mobile-first responsive design approach, ensuring excellent performance and usability across smartphones, tablets, and desktop devices.",
  },
  {
    question: "Can you redesign my existing website?",
    answer:
      "Absolutely. We modernize outdated websites with improved UI/UX, faster performance, better security, responsive layouts, and SEO-friendly architecture while preserving your brand identity.",
  },
  {
    question: "Will my website be SEO-friendly?",
    answer:
      "Yes. We develop websites with clean code, optimized page speed, structured metadata, responsive design, schema-ready architecture, and technical SEO best practices to improve search engine visibility.",
  },
  {
    question: "Can I update my website content myself?",
    answer:
      "Yes. We can build your website with an easy-to-manage CMS, allowing you to update text, images, blogs, and pages without requiring technical expertise.",
  },
  {
    question: "Do you provide website maintenance and support?",
    answer:
      "Yes. We offer ongoing website maintenance services including security updates, backups, bug fixes, performance monitoring, software updates, and technical support to keep your website running smoothly",
  },
];

const Webdoubt = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="webdoubt-section">
      <div className="webdoubt-container">
        <span className="webdoubt-eyebrow">FAQ</span>

        <h2 className="webdoubt-title">
          Your Website Development Doubts Clarified?
        </h2>

        <div className="webdoubt-faq-grid">
          {faqData.map((item, index) => (
            <div
              className={`webdoubt-faq-item ${
                activeIndex === index ? "active" : ""
              }`}
              key={index}
            >
              <div
                className="webdoubt-faq-question-row"
                onClick={() => toggleFaq(index)}
              >
                <span className="webdoubt-faq-number">
                  {String(index + 1).padStart(2, "0")}
                </span>

                <h3 className="webdoubt-faq-question">{item.question}</h3>

                <button className="webdoubt-faq-btn" aria-label="Toggle answer">
                  <img
                    src={arrowIcon}
                    alt=""
                    className={`webdoubt-faq-icon ${
                      activeIndex === index ? "rotate" : ""
                    }`}
                  />
                </button>
              </div>

              <div
                className={`webdoubt-faq-answer-wrapper ${
                  activeIndex === index ? "show" : ""
                }`}
              >
                <div className="webdoubt-faq-answer-inner">
                  <p className="webdoubt-faq-answer">{item.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Webdoubt;